import { Box, Heading, Stack, Text } from '@trmediaab/zebra';
import type { Ticket } from '@trmediaab/zebra-types/trhub';

import AltContentDivider from '../../../components/AltContentDivider';
import ErrorMessage from '../../../components/ErrorMessage';
import NextButton from '../../../components/NextButton';
import type { ErrorWithMessage } from '../../../types/ErrorWithMessage';

interface ConfirmProps {
  ticket: Ticket;
  error: ErrorWithMessage | undefined;
  onPunch: () => void;
  onCancel: () => void;
}

const Confirm = ({ ticket, error, onPunch, onCancel }: ConfirmProps) => (
  <>
    <Heading.h4 variant="checkout" textAlign="center">
      Vill du använda ditt
      <br />
      klippkort för att köpa
      <br />
      det här tipsmaterialet?
    </Heading.h4>
    <Text.p textAlign="center" px="3">
      Du har {ticket.remaining} omgångar kvar på ditt klippkort: {ticket.name},{' '}
      {ticket.punches} omgångar
    </Text.p>
    <Stack between="2,5" pt="3">
      {error && (
        <Box mb="2">
          <ErrorMessage error={error} />
        </Box>
      )}
      <NextButton label="Använd klippkort" onClick={onPunch} />
      <AltContentDivider />
      <NextButton label="Avbryt" variant="secondary" onClick={onCancel} />
    </Stack>
  </>
);

export default Confirm;
